import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMeetWhen = (props) => /* @__PURE__ */ _jsxs("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 56 56",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Features_3",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				id: "When icon background",
				x: 2,
				y: 8,
				width: 52,
				height: 46,
				rx: 8,
				fill: "url(#paint0_linear_0_5)"
			}),
			/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse 277",
				cx: 28,
				cy: 33,
				r: 15,
				stroke: "#DFCBF5",
				strokeOpacity: .1,
				strokeWidth: 1.5,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse 278",
				cx: 28,
				cy: 33,
				r: 10,
				stroke: "#DFCBF5",
				strokeOpacity: .3,
				strokeWidth: 1.5,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Ellipse 279",
				filter: "url(#filter0_d_0_5)",
				children: /* @__PURE__ */ _jsx("circle", {
					cx: 28,
					cy: 33,
					r: 5,
					fill: "url(#paint1_linear_0_5)"
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "When icon part",
				d: "M9 4C9 3.44772 9.44772 3 10 3V3C10.5523 3 11 3.44772 11 4V12C11 12.5523 10.5523 13 10 13V13C9.44772 13 9 12.5523 9 12V4Z",
				fill: "url(#paint2_linear_0_5)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "When icon part_2",
				d: "M15 4C15 3.44772 15.4477 3 16 3V3C16.5523 3 17 3.44772 17 4V12C17 12.5523 16.5523 13 16 13V13C15.4477 13 15 12.5523 15 12V4Z",
				fill: "url(#paint3_linear_0_5)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "When icon part_3",
				d: "M21 4C21 3.44772 21.4477 3 22 3V3C22.5523 3 23 3.44772 23 4V12C23 12.5523 22.5523 13 22 13V13C21.4477 13 21 12.5523 21 12V4Z",
				fill: "url(#paint4_linear_0_5)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "When icon part_4",
				d: "M27 4C27 3.44772 27.4477 3 28 3V3C28.5523 3 29 3.44772 29 4V12C29 12.5523 28.5523 13 28 13V13C27.4477 13 27 12.5523 27 12V4Z",
				fill: "url(#paint5_linear_0_5)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "When icon part_5",
				d: "M33 4C33 3.44772 33.4477 3 34 3V3C34.5523 3 35 3.44772 35 4V12C35 12.5523 34.5523 13 34 13V13C33.4477 13 33 12.5523 33 12V4Z",
				fill: "url(#paint6_linear_0_5)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "When icon part_6",
				d: "M39 4C39 3.44772 39.4477 3 40 3V3C40.5523 3 41 3.44772 41 4V12C41 12.5523 40.5523 13 40 13V13C39.4477 13 39 12.5523 39 12V4Z",
				fill: "url(#paint7_linear_0_5)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "When icon part_7",
				d: "M45 4C45 3.44772 45.4477 3 46 3V3C46.5523 3 47 3.44772 47 4V12C47 12.5523 46.5523 13 46 13V13C45.4477 13 45 12.5523 45 12V4Z",
				fill: "url(#paint8_linear_0_5)"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_0_5",
			x: 19,
			y: 24,
			width: 18,
			height: 18,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.00392157 0 0 0 0 0.937255 0 0 0 0 0.854902 0 0 0 1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_0_5"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_0_5",
					result: "shape"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_0_5",
			x1: 28,
			y1: 8,
			x2: 28,
			y2: 54,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#DFCBF5",
				stopOpacity: .4
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#DFCBF5",
				stopOpacity: .1
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_0_5",
			x1: 23,
			y1: 28,
			x2: 25.9715,
			y2: 39.8214,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#00E1FF" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#00FFB3"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint2_linear_0_5",
			x1: 10,
			y1: 3,
			x2: 10,
			y2: 13,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#DFCBF5",
				stopOpacity: .1
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#DFCBF5",
				stopOpacity: .4
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint3_linear_0_5",
			x1: 16,
			y1: 3,
			x2: 16,
			y2: 13,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#DFCBF5",
				stopOpacity: .1
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#DFCBF5",
				stopOpacity: .4
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint4_linear_0_5",
			x1: 22,
			y1: 3,
			x2: 22,
			y2: 13,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#DFCBF5",
				stopOpacity: .1
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#DFCBF5",
				stopOpacity: .4
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint5_linear_0_5",
			x1: 28,
			y1: 3,
			x2: 28,
			y2: 13,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#DFCBF5",
				stopOpacity: .1
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#DFCBF5",
				stopOpacity: .4
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint6_linear_0_5",
			x1: 34,
			y1: 3,
			x2: 34,
			y2: 13,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#DFCBF5",
				stopOpacity: .1
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#DFCBF5",
				stopOpacity: .4
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint7_linear_0_5",
			x1: 40,
			y1: 3,
			x2: 40,
			y2: 13,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#DFCBF5",
				stopOpacity: .1
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#DFCBF5",
				stopOpacity: .4
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint8_linear_0_5",
			x1: 46,
			y1: 3,
			x2: 46,
			y2: 13,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#DFCBF5",
				stopOpacity: .1
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#DFCBF5",
				stopOpacity: .4
			})]
		})
	] })]
});
export default SvgMeetWhen;
